interface FormRowProps {
  type?: string;
  name: string;
  labelText?: string;
  defaultValue?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormRow = ({ type = "text", name, labelText, defaultValue = "", onChange }: FormRowProps) => {
  return (
    <div className="form-row">
      <label className="form-label" htmlFor={name}>
        {labelText || name}
      </label>
      <input className="form-input" type={type} id={name} name={name} defaultValue={defaultValue} required onChange={e => onChange?.(e)} />
    </div>
  );
};

export default FormRow;
